export enum ManagementQueryParam {
  PAGE = 'page',
  SEARCH = 'search',
  CLIENT_TYPE = 'clientType',
  ACTIVE = 'active',
  TAB = 'tab',
}
